import { connect } from "react-redux";
import get from "lodash/get";

import {
  getDevice as onGetDevice,
  updateDevice as onUpdateDevice,
  createConnectedSensor as onCreateConnectedSensor,
  deleteConnectedSensor as onDeleteConnectedSensor,
  createCalibration as onCreateCalibration,
  deleteCalibration as onDeleteCalibration,
  replaceDevice as onReplaceDevice,
  clearCurrentDevice as onClearCurrentDevice,
  uploadCalibrations as onUploadCalibrations,
  downloadCalibrations as onDownloadCalibrations,
  createCommand as onCreateCommand,
  deleteCommand as onDeleteCommand,
} from "./../../actions/devicesAction";

const mapStateToProps = (state) => ({
  currentDeviceDataState: state.currentDevice.currentDeviceDataState,
  currentDeviceUpdateDataState: state.currentDevice.currentDeviceUpdateDataState,
  createConnectedSensorDataState: state.currentDevice.createConnectedSensorDataState,
  deleteConnectedSensorDataState: state.currentDevice.deleteConnectedSensorDataState,
  createCalibrationDataState: state.currentDevice.createCalibrationDataState,
  deleteCalibrationDataState: state.currentDevice.deleteCalibrationDataState,
  replaceDeviceDataState: state.currentDevice.replaceDeviceDataState,
  uploadCalibrationsDataState: state.currentDevice.uploadCalibrationsDataState,
  downloadCalibrationsDataState: state.currentDevice.downloadCalibrationsDataState,
  createCommandDataState: state.currentDevice.createCommandDataState,
  deleteCommandDataState: state.currentDevice.deleteCommandDataState,
  currentDevice: get(state, ["currentDevice", "currentDevice"], null),
  errors: get(state, ["currentDevice", "errors"], []),
});

const mapDispatchToProps = {
  onGetDevice,
  onUpdateDevice,
  onCreateConnectedSensor,
  onDeleteConnectedSensor,
  onCreateCalibration,
  onDeleteCalibration,
  onReplaceDevice,
  onClearCurrentDevice,
  onUploadCalibrations,
  onDownloadCalibrations,
  onCreateCommand,
  onDeleteCommand,
};

const withCurrentDevices = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withCurrentDevices };
